import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { differenceInDays } from 'date-fns';
import { RaptorJobFormValues } from '../../../../RaptorJobValidationSchema';
import { FormikRadioGroup } from '@/common/presentation/components/forms/fields/FormikRadioGroup';
import { FormikDatePicker } from '@/common/presentation/components/forms/fields/FormikDatePicker';
import { DailyDispatchTimes } from '../../components/DailyDispatchTimes';
import { MultiDayJobRecurrence } from '../../components/MultiDayJobRecurrence';
import tid from '@/common/application/utils/tid';

const recurrenceOptions = [
  { value: 'single', label: 'Single-Day Job' },
  { value: 'multi', label: 'Multi-Day Job' }
];

export function RecurrenceSection() {
  const { values, setFieldValue } = useFormikContext<RaptorJobFormValues>();

  return (
    <>
      <Typography variant="h6" component="div" sx={{ fontSize: '1rem', mb: '12px', fontWeight: 600 }}>
        Recurrence
      </Typography>
      <FormikRadioGroup<RaptorJobFormValues> id="recurrence" options={recurrenceOptions} row />
      <Box sx={{ display: 'flex', gap: { xs: '0px', sm: '12px' }, flexDirection: { xs: 'column', sm: 'row' } }}>
        <FormikDatePicker<RaptorJobFormValues>
          id="startDate"
          label="Start Date"
          required
          sx={{ flex: 1 }}
          onChange={(date) => {
            if (typeof values.estimatedDurationDays === 'number' && values.endDate && date) {
              setFieldValue('estimatedDurationDays', differenceInDays(values.endDate, date));
            }
          }}
          {...tid('jobs:create:start-date-input')}
        />
        <MultiDayJobRecurrence />
      </Box>
      <DailyDispatchTimes />
    </>
  );
}
